import React, { useEffect, useState, useRef } from 'react';
import { Device } from "@twilio/voice-sdk";
import '.././App.css';

function TwilioClicktoDial() {
  const deviceRef = useRef(null);
  const callRef = useRef(null);

  const [status, setStatus] = useState("idle"); // idle | ready | calling | oncall | error
  const [toNumber, setToNumber] = useState("+919818339777");
  const [callSid, setCallSid] = useState(null);

  // Recording state
  const [recordingSid, setRecordingSid] = useState(null);
  const [recordingState, setRecordingState] = useState("stopped"); // stopped | in-progress | paused

  useEffect(() => {
    let mounted = true;
    window.addEventListener('message', handleMessage, false);

    return () => {
      window.removeEventListener('message', handleMessage);
    };

  }, []);

  function wireCallEvents(call) {
    call.on("accept", () => {
      setStatus("Connected");
      //window.parent.postMessage({data: {type: "state", state: "in-progress"}}, "*");

      const sid =
        (call.parameters && (call.parameters.CallSid || call.parameters.callSid)) ||
        null;
      setCallSid(sid);

      window.parent.postMessage({ data: { type: "callsid", serverCallId: sid } }, "*");
    });

    call.on("disconnect", () => {
      setStatus("disconnected");
      setCallSid(null);
      callRef.current = null;
      //window.parent.postMessage({data: {type: "state", state: "completed"}}, "*");
      console.log("Disposing call agent");
    });

    call.on("error", (e) => {
      console.error("[Call error]", e.code, e.message);
      // Busy / Decline detection
      if (e.code === 486) {
        setStatus("Busy");
      } else if (e.code === 603) {
        setStatus("Declined");
      } else if (e.code === 480) {
        setStatus("No Reachable");
      } else if (e.code === 404) {
        setStatus("Invalid Number");
      } else {
        setStatus("failed");
      }

      callRef.current = null;
    });
  }

  // ---- Recording controls (server-side REST calls) ----
  const startRecording = async () => {
    if (!callSid) return;
    const r = await fetch("/recordings/start", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ callSid }),
    });
    if (r.ok) {
      const { recordingSid } = await r.json();
      setRecordingSid(recordingSid);
      setRecordingState("in-progress");
    } else {
      console.error(await r.text());
    }
  };

  const pauseRecording = async () => {
    if (!recordingSid) return;
    const r = await fetch("/recordings/pause", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ recordingSid }),
    });
    if (r.ok) setRecordingState("paused");
    else console.error(await r.text());
  };

  const resumeRecording = async () => {
    if (!recordingSid) return;
    const r = await fetch("/recordings/resume", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ recordingSid }),
    });
    if (r.ok) setRecordingState("in-progress");
    else console.error(await r.text());
  };

  const stopRecording = async () => {
    if (!recordingSid) return;
    const r = await fetch("/recordings/stop", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ recordingSid }),
    });
    if (r.ok) {
      setRecordingState("stopped");
      setRecordingSid(null);
    } else {
      console.error(await r.text());
    }
  };

  const handleMessage = async (event) => {
    if (event.data.type) {
      console.log("RA(T): " + event.data.type);
      if (event.data.type === 'startCall') {
        const device = new Device(event.data.data.token, { logLevel: "info" });
        deviceRef.current = device;

        device.on("registered", () => setStatus("ready"));
        device.on("error", () => setStatus("error"));
        await device.register();

        try {
          console.log("ConnectionId: " + JSON.stringify(event.data.data));
          const call = await deviceRef.current.connect({
            params: {
              FromNumber: event.data.data.fromPhoneNumber,
              To: event.data.data.phoneToCall,
              recordCall: event.data.data.isRecord ? "y" : "n",
              connectionId: event.data.data.connectionId,
              productCode: event.data.data.productCode
            },
          });

          callRef.current = call;
          wireCallEvents(call);
        } catch (e) {
          console.error(e);
        }
      } else if (event.data.type === 'mute') {
        try {
          await callRef.current?.mute();
        } catch (e) {
          console.log("RA(T): Mute");
          console.error(e);
        }
      } else if (event.data.type === 'unmute') {
        try {
          await callRef.current?.unmute();
        } catch (e) {
          console.log("RA(T): Unmute");
          console.error(e);
        }
      } else if (event.data.type === 'endcall') {
        try {
          await callRef.current?.disconnect();
        } catch (e) {
          console.log("RA(T): Disconect");
          console.error(e);
        }
      }
    }
  };

  return (
    <div className="Twilio Call App">
      <div>
        <p>Current State: {status}</p>
      </div>
    </div>
  );
}

export default TwilioClicktoDial;